'use client';

import MuiTextField, {TextFieldProps} from '@new-components/atoms/MuiTextField';
import MenuItem from '@mui/material/MenuItem';
import SvgIcon from '@mui/material/SvgIcon';

export type CountrySelectProps = Pick<
  TextFieldProps,
  'name' | 'defaultValue' | 'value' | 'disabled' | 'defaultValue'
> & {
  options: Record<'label' | 'value' | 'displayLabel', string>[];
  onChange?: (value: string) => void;
  hide?: boolean;
};
export function CountrySelectInput({
  options,
  onChange,
  hide,
  ...props
}: CountrySelectProps) {
  if (hide) return <></>;
  return (
    <MuiTextField
      {...props}
      select
      variant='outlined'
      id='country-select'
      onChange={(e) => {
        if (onChange) onChange(e.target.value);
      }}
      sx={{
        paddingLeft: 0,
        minWidth: '100px',
        gap: '6px',
        ['& .MuiOutlinedInput-root']: {
          fieldset: {
            display: 'none',
          },
        },
      }}
      SelectProps={{
        renderValue: (selected) => {
          const selectedOption = options.find(
            (option) => option.value === selected
          );
          return selectedOption ? selectedOption.displayLabel : '';
        },
        IconComponent: (props) => (
          <SvgIcon {...props}>
            <svg
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M5 7.5L10 12.5L15 7.5'
                stroke='#98A2B3'
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </SvgIcon>
        ),
      }}
      inputProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px 12px',
        },
      }}>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </MuiTextField>
  );
}
